import { Button } from "@repo/ui/components/ui/button";
import { ClipboardList, Stethoscope } from "lucide-react";
import type { BookingFlow } from "./booking-store";

interface ModeSelectProps {
  onSelect: (flow: BookingFlow) => void;
}

const MODES = [
  {
    flow: "consult" as const,
    title: "Consultation",
    description: "Book a patient consultation",
    icon: Stethoscope,
  },
  {
    flow: "protocols" as const,
    title: "Protocols",
    description: "Book one or more visit protocols",
    icon: ClipboardList,
  },
];

export function ModeSelect({ onSelect }: ModeSelectProps) {
  return (
    <div className="grid grid-cols-1 gap-2">
      {MODES.map((mode) => (
        <Button
          key={mode.flow}
          variant="outline"
          onClick={() => onSelect(mode.flow)}
          className="flex h-auto items-center gap-3 px-4 py-3 justify-start"
        >
          <mode.icon className="h-5 w-5 shrink-0 text-muted-foreground" />
          <div className="text-left">
            <div className="font-medium">{mode.title}</div>
            <div className="text-sm text-muted-foreground">{mode.description}</div>
          </div>
        </Button>
      ))}
    </div>
  );
}
